export const LicenseExpiringModalActionTypes = {
  SHOW_LICENSE_EXPIRING_MODAL: 'SHOW_LICENSE_EXPIRING_MODAL',
  HIDE_LICENSE_EXPIRING_MODAL: 'HIDE_LICENSE_EXPIRING_MODAL'
};

export const showLicenseExpiringModal = (daysRemaining) => ({
  type: LicenseExpiringModalActionTypes.SHOW_LICENSE_EXPIRING_MODAL,
  payload: { daysRemaining }
});

export const hideLicenseExpiringModal = () => ({
  type: LicenseExpiringModalActionTypes.HIDE_LICENSE_EXPIRING_MODAL
});
